import React from 'react'
import _ from 'lodash';
var tu = require('tracking-url');

class Fulfillment extends React.Component {
  constructor(props) {
    super(props)
    this.renderFulfillment = this.renderFulfillment.bind(this)
  }
  renderFulfillment() {
    if (this.props.order && this.props.order.fulfillment) {
      const { fulfillment } = this.props.order;
      const track = tu(fulfillment.tracking_number)
      if (fulfillment.hasOwnProperty('sage_order_id')) {
        return (
          <div key={fulfillment.tracking_number}>
            <p key="UPS">Carrier: <strong>UPS</strong></p><br />
            <p key={fulfillment.sage_order_id}>SAGE ORDER ID: <strong>{fulfillment.sage_order_id}</strong></p><br />
            <p key={fulfillment.ship_service}>SHIPPING SERVICE: <strong>{fulfillment.ship_service}</strong></p><br />
            <p key={fulfillment.xcarrier_delivery_id}>CARRIER DELIVER ID: <strong>{fulfillment.xcarrier_delivery_id}</strong></p><br />
            <h3 key={`${fulfillment.tracking_number}h3`}>
              Tracking Number: 
              {(track && track.url) 
              ? <a href={track.url} target="_blank" rel="noopener noreferrer">{fulfillment.tracking_number}</a>
              : <span>{fulfillment.tracking_number}</span>}
            </h3>
          </div>
        )
      } else {
        const trackingNumber= fulfillment && fulfillment.tracking_number
        const trackingURL = fulfillment && fulfillment.tracking_url
            return (
              <div key={trackingNumber}>
                  {(trackingURL)
                    ? <span>Tracking Number: <a target="_blank" href={trackingURL}>{trackingNumber}</a></span>
                    : <p>Tracking Number: <strong>{trackingNumber}</strong></p>
                  }
              </div>
            )
      }
    } else {
      return "";
    }
  }
  render() {
    return (
      <div>
        <h2>Fulfillment</h2>
        <div style={{ paddingLeft: '40px', paddingBottom: '20px' }}>
          {this.renderFulfillment()}
        </div>
      </div>
    )
  }

}
export default Fulfillment;


// WEBPACK FOOTER //
// ./src/components/orders/Common/Fulfillment.js